import api from '.';

interface DocumentProjectPositionWorkflowStep {
  documentId: number;
  projectPositionWorkflowStepId: number;
}

export async function createDocumentProjectPositionWorkflowStep(
  createDocumentProjectPositionWorkflowStep: DocumentProjectPositionWorkflowStep
) {
  const { data } = await api.post(
    '/document-project-position-workflow-steps',
    createDocumentProjectPositionWorkflowStep
  );
  return data;
}

export async function deleteDocumentProjectPositionWorkflowStep(
  params: DocumentProjectPositionWorkflowStep
) {
  const { data } = await api.delete(
    '/document-project-position-workflow-steps',
    {
      params
    }
  );
  return data;
}
